import React, { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom';
import { auth, db, storage } from './firebase'; 
import { signOut, updatePassword, onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs, addDoc, doc, updateDoc, deleteDoc, getDoc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage"; 
import './Bidder.css';


// --- HELPER: 5:00 PM IST CLOSING RULE ---
const isTenderClosed = (dateString, timeString) => {
  if (!dateString) return false;
  const time = timeString || "18:30"; // Fallback for older tenders
  const closeTime = new Date(`${dateString}T${time}:00+05:30`);
  const now = new Date();
  return now > closeTime;
};

function BidderDashboard() {
  const navigate = useNavigate();
  
  // USER STATE
  const [currentUser, setCurrentUser] = useState(null); 
  const [authLoading, setAuthLoading] = useState(true);

  // --- CONFIGURATION ---
  const API_KEY = "dd0336f4-94f7-11ef-8b17-0200cd936042";
  const TEMPLATE_NAME = "Housefed";

  // --- STATE ---
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  
  const [activeTab, setActiveTab] = useState('all'); 
  const [tenders, setTenders] = useState([]);
  const [myBids, setMyBids] = useState([]);
  
  // RANKING STATE
  const [myRanks, setMyRanks] = useState({});

  // Bid Modal State
  const [showModal, setShowModal] = useState(false);
  const [selectedTender, setSelectedTender] = useState(null);
  const [bidForm, setBidForm] = useState({ amount: "", file: null, existingFileUrl: "" });
  const [editingBidId, setEditingBidId] = useState(null);
  const [bidChecklist, setBidChecklist] = useState([false, false, false, false, false, false]);
  const allBidChecked = bidChecklist.every(Boolean);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const bidChecklistItems = [
    'ਮੈਂ ਟੈਂਡਰ ਦਸਤਾਵੇਜ਼, ਸਾਰੀਆਂ ਸ਼ਰਤਾਂ ਅਤੇ ਕੰਮ ਦੇ ਦਾਇਰੇ (Scope of Work) ਨੂੰ ਧਿਆਨ ਨਾਲ ਪੜ੍ਹ ਅਤੇ ਸਮਝ ਲਿਆ ਹੈ।',
    'ਮੈਂ ਟੈਂਡਰ ਵਿੱਚ ਦੱਸੀਆਂ ਗਈਆਂ ਸਾਰੀਆਂ ਆਮ ਅਤੇ ਖਾਸ ਸ਼ਰਤਾਂ ਨੂੰ ਬਿਨਾਂ ਕਿਸੇ ਇਤਰਾਜ਼ ਦੇ ਸਵੀਕਾਰ ਕਰਦਾ ਹਾਂ।',
    'ਮੈਂ ਸਹਿਮਤ ਹਾਂ ਕਿ ਮੇਰੀ ਬੋਲੀ ਦੀਆਂ ਕੀਮਤਾਂ ਟੈਂਡਰ ਵਿੱਚ ਮੰਗੀ ਗਈ ਮਿਆਦ ਲਈ ਵੈਧ ਰਹਿਣਗੀਆਂ ਅਤੇ ਮੈਂ ਇਸ ਮਿਆਦ ਦੌਰਾਨ ਕੀਮਤ ਵਧਾਉਣ ਦੀ ਮੰਗ ਨਹੀਂ ਕਰਾਂਗਾ।',
    'ਮੈਂ ਪ੍ਰੋਜੈਕਟ ਵਾਲੀ ਥਾਂ ਦਾ ਦੌਰਾ ਕਰ ਲਿਆ ਹੈ ਅਤੇ ਕੰਮ ਦੀਆਂ ਜ਼ਮੀਨੀ ਹਕੀਕਤਾਂ ਅਤੇ ਚੁਣੌਤੀਆਂ ਨੂੰ ਚੰਗੀ ਤਰ੍ਹਾਂ ਸਮਝ ਲਿਆ ਹੈ (ਜੇਕਰ ਟੈਂਡਰ ਵਿੱਚ ਮੰਗ ਕੀਤੀ ਗਈ ਹੋਵੇ)।',
    "ਮੈਂ ਘੋਸ਼ਣਾ ਕਰਦਾ ਹਾਂ ਕਿ ਮੇਰੇ ਵੱਲੋਂ ਅਪਲੋਡ ਕੀਤੇ ਗਏ ਸਾਰੇ ਕਾਗਜ਼ਾਤ ( ਜੇਕਰ ਟੈਂਡਰ ਵਿਚ ਮੰਗੇ ਗਏ ਹਨ।), 100% ਅਸਲੀ ਅਤੇ ਸਹੀ ਹਨ। ਗਲਤ ਪਾਏ ਜਾਣ 'ਤੇ ਮੇਰੀ ਬੋਲੀ ਰੱਦ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ।",
    'ਮੈਂ ਤਸਦੀਕ ਕਰਦਾ ਹਾਂ ਕਿ ਮੈਂ ਹੋਰ ਬੋਲੀਕਾਰਾਂ ਨਾਲ ਮਿਲ ਕੇ ਕੀਮਤਾਂ ਤੈਅ ਕਰਨ (Cartelization) ਜਾਂ ਟੈਂਡਰ ਪ੍ਰਕਿਰਿਆ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਨ ਦੀ ਕੋਈ ਗੈਰ-ਕਾਨੂੰਨੀ ਕੋਸ਼ਿਸ਼ ਨਹੀਂ ਕੀਤੀ ਹੈ।'
  ];

  // RESULT POPUP STATE
  const [resultPopup, setResultPopup] = useState(null);
  const [resultBids, setResultBids] = useState([]);
  const [loadingResults, setLoadingResults] = useState(false);

  // Password Change State
  const [showPassModal, setShowPassModal] = useState(false);
  const [passForm, setPassForm] = useState({ newPass: "", confirmPass: "" });

  // Profile & OTP State
  const [formData, setFormData] = useState({ name: "", address: "", gst: "", phone: "", isVerified: false });
  const [otp, setOtp] = useState("");
  const [sessionId, setSessionId] = useState(null); 
  const [verificationStep, setVerificationStep] = useState("IDLE");
  const [verifyError, setVerifyError] = useState("");
  const [isProfileExpanded, setIsProfileExpanded] = useState(true);
  
  // NEW: OTP Resend Timer State
  const [resendTimer, setResendTimer] = useState(0);

  // --- OTP TIMER HOOK ---
  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  // --- INITIAL LOAD ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user); 
        fetchUserData(user); 
      } else {
        setAuthLoading(false);
        navigate('/login'); // Updated to point to main login
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const fetchUserData = async (user) => {
    try {
      // 1. Fetch Profile
      const userRef = doc(db, "users", user.uid); 
      const docSnap = await getDoc(userRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        setFormData({
            name: data.name || "", address: data.address || "", gst: data.gst || "", 
            phone: data.phone || "", isVerified: data.phoneVerified === true
        });
        if(data.phoneVerified) setIsProfileExpanded(false);
      } else {
        setFormData(prev => ({ ...prev, email: user.email, isVerified: false })); 
      }

      // 2. Fetch Active Tenders
      const tQuery = query(collection(db, "tenders"));
      const tSnap = await getDocs(tQuery);
      const fetchedTenders = tSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTenders(fetchedTenders);

      // 3. Fetch My Bids
      const bQuery = query(collection(db, "bids"), where("userId", "==", user.uid)); 
      const bSnap = await getDocs(bQuery);
      const fetchedBids = bSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setMyBids(fetchedBids);

      // 4. Calculate Rankings for Closed Tenders
      const closedTenderIds = fetchedTenders.filter(t => isTenderClosed(t.closeDate)).map(t => t.id);
      const myClosedBids = fetchedBids.filter(b => closedTenderIds.includes(b.tenderId));

      if (myClosedBids.length > 0) {
          const newRanks = {};
          await Promise.all(myClosedBids.map(async (myBid) => {
              const allBidsQuery = query(collection(db, "bids"), where("tenderId", "==", myBid.tenderId));
              const allBidsSnap = await getDocs(allBidsQuery);
              const allBids = allBidsSnap.docs.map(d => ({ userId: d.data().userId, amount: parseFloat(d.data().amount) }));
              allBids.sort((a, b) => a.amount - b.amount);
              const myIndex = allBids.findIndex(b => b.userId === user.uid);
              newRanks[myBid.tenderId] = myIndex; 
          }));
          setMyRanks(newRanks);
      }

    } catch (err) { console.error(err); }
    setLoading(false);
    setAuthLoading(false);
  };

  // --- AUTH & PROFILE ---
  const handleLogout = async () => { await signOut(auth); navigate('/'); };
  const isEmailUser = currentUser?.providerData.some(p => p.providerId === 'password');

  const handlePasswordChange = async (e) => {
      e.preventDefault();
      if(passForm.newPass !== passForm.confirmPass) { alert("Passwords do not match!"); return; }
      if(passForm.newPass.length < 6) { alert("Password must be at least 6 characters."); return; }
      try {
          await updatePassword(currentUser, passForm.newPass);
          alert("✅ Password changed successfully!");
          setShowPassModal(false); setPassForm({ newPass: "", confirmPass: "" });
      } catch (error) { 
          if (error.code === 'auth/requires-recent-login') {
            alert("For security reasons, you need a fresh session to change your password. Please log out, log back in, and try again.");
          } else {
            alert("Error: " + error.message); 
          }
      }
  };

  /// --- OTP LOGIC ---
  const sendOtp = async () => {
    const cleanPhone = formData.phone.replace(/[^0-9]/g, '');
    
    if(!formData.name || !formData.address || !formData.gst || cleanPhone.length < 10) { 
        setVerifyError("Please fill all details (Name, Address, GST/Aadhar) and a 10-digit phone number."); 
        return; 
    }
    
    setVerifyError(""); 
    setIsSendingOtp(true); // Disable button
    
    const finalPhoneNumber = cleanPhone.length > 10 ? `+${cleanPhone}` : `+91${cleanPhone}`;
    const url = `https://2factor.in/API/V1/${API_KEY}/SMS/${finalPhoneNumber}/AUTOGEN/${TEMPLATE_NAME}`;
    
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.Status === "Success") {
          setSessionId(data.Details); 
          setVerificationStep("OTP_SENT"); 
          setResendTimer(60); 
          alert(`OTP Sent successfully to ${finalPhoneNumber}`);
      } else { setVerifyError("Gateway Error: " + data.Details); }
    } catch (err) { 
        console.error("OTP API Error:", err); 
        setVerifyError("Error sending OTP."); 
    } finally {
        setIsSendingOtp(false); // Re-enable button
    }
  };

  const verifyOtpAndSave = async () => {
    if (!sessionId) { setVerifyError("Session expired. Please request OTP again."); return; }
    setVerifyError("");
    setIsVerifyingOtp(true); // Disable button
    
    const url = `https://2factor.in/API/V1/${API_KEY}/SMS/VERIFY/${sessionId}/${otp}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.Status === "Success" && data.Details === "OTP Matched") {
          await setDoc(doc(db, "users", currentUser.uid), { 
            name: formData.name, address: formData.address, gst: formData.gst, 
            phone: formData.phone, phoneVerified: true, updatedAt: new Date() 
          }, { merge: true });
          alert("✅ Profile Verified & Saved!"); 
          setFormData(prev => ({ ...prev, isVerified: true })); 
          setVerificationStep("IDLE"); 
          setIsProfileExpanded(false);
      } else { setVerifyError("❌ Invalid OTP. Please try again."); }
    } catch (err) { 
        console.error("Verification Error:", err); 
        setVerifyError("Error verifying OTP."); 
    } finally {
        setIsVerifyingOtp(false); // Re-enable button
    }
  };

  // --- DASHBOARD ACTIONS ---
  const getDaysLeft = (closeDate) => {
    if (isTenderClosed(closeDate)) return -1;
    const today = new Date(); const close = new Date(closeDate);
    return Math.ceil((close - today) / (1000 * 60 * 60 * 24));
  };

  const getBidStatus = (bid) => {
      if (myRanks[bid.tenderId] !== undefined) {
          const rank = myRanks[bid.tenderId];
          if (rank === 0) return <span className="status-pill winner">🏆 L1 WINNER ( Your are selected )</span>;
          if (rank === 1) return <span className="status-pill backup">🥈 L2 BACKUP (Your are a backup candidate) </span>;
          return <span className="status-pill lost">❌ NOT SELECTED</span>;
      }
      return <span className="status-pill submitted">SUBMITTED</span>;
  };

  const openResult = async (tender) => {
      setResultPopup(tender);
      setLoadingResults(true);
      setResultBids([]);
      try {
          const q = query(collection(db, "bids"), where("tenderId", "==", tender.id));
          const snap = await getDocs(q);
          const bids = snap.docs.map(d => d.data());
          bids.sort((a, b) => parseFloat(a.amount) - parseFloat(b.amount));
          setResultBids(bids);
      } catch (e) { console.error(e); }
      setLoadingResults(false);
  };

  const openApplyModal = (tender) => {
    if(!formData.isVerified) { alert("⚠️ Please complete your profile first."); setIsProfileExpanded(true); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    setSelectedTender(tender); setBidForm({ amount: "", file: null, existingFileUrl: "" });
    setBidChecklist([false, false, false, false, false, false]); setEditingBidId(null); setShowModal(true);
  };

  const openEditModal = (bid) => {
    const relatedTender = tenders.find(t => t.id === bid.tenderId);
    if (relatedTender && isTenderClosed(relatedTender.closeDate)) { alert("This tender is closed."); return; }
    setSelectedTender(relatedTender || { title: bid.tenderTitle, closeDate: bid.tenderCloseDate, closeTime: bid.tenderCloseTime, fileUrl: null });
    setBidForm({ amount: bid.amount, file: null, existingFileUrl: bid.fileUrl });
    setBidChecklist([true, true, true, true, true, true]); setEditingBidId(bid.id); setShowModal(true);
  };

  const handleSubmitBid = async (e) => {
    e.preventDefault();
    if (!allBidChecked) { alert("Please agree to all mandatory conditions."); return; }
    setSubmitting(true);
    try {
      let fileUrl = bidForm.existingFileUrl || "";
      if (bidForm.file) {
        const storageRef = ref(storage, `bids/${currentUser.uid}_${Date.now()}_${bidForm.file.name}`);
        const snapshot = await uploadBytes(storageRef, bidForm.file);
        fileUrl = await getDownloadURL(snapshot.ref);
      }
      const bidData = { 
          amount: bidForm.amount, fileUrl: fileUrl, updatedAt: new Date(),
          bidderPhone: formData.phone, bidderAddress: formData.address, bidderEmail: currentUser.email
      };
      if (editingBidId) {
        await updateDoc(doc(db, "bids", editingBidId), bidData);
        alert("Bid updated successfully!");
      } else {
        await addDoc(collection(db, "bids"), {
  tenderId: selectedTender.id, tenderTitle: selectedTender.title, 
  tenderCloseDate: selectedTender.closeDate, tenderCloseTime: selectedTender.closeTime || "18:30",
  userId: currentUser.uid, bidderName: formData.name, status: "submitted", submittedAt: new Date(), ...bidData
});
        alert("Application submitted successfully!");
      }
      
      // NEW: Trigger processing state and WAIT for fresh data
      setLoading(true); 
      setShowModal(false); 
      await fetchUserData(currentUser); // <--- AWAIT forces it to wait for the new edited data
      setActiveTab('my-bids');
      
    } catch (error) { alert("Error: " + error.message); }
    setSubmitting(false);
  };

  const handleDeleteBid = async (bidId) => {
      if(window.confirm("Are you sure you want to withdraw this bid?")) {
          await deleteDoc(doc(db, "bids", bidId)); fetchUserData(currentUser);
      }
  }

  if (authLoading || loading) return <div className="loading-screen">Processing data, please wait...</div>;

  return (
    <div className="bidder-dashboard">
      <header className="bidder-header">
        <h2>Vendor Dashboard</h2>
        <div className="header-right">
          {/* Change Password hidden for Google users */}
          {isEmailUser && (<button onClick={() => setShowPassModal(true)} className="btn-home-small" style={{marginRight:'10px', background:'#f39c12', borderColor:'#e67e22'}}>🔑 Change Password</button>)}
          <button onClick={() => navigate('/')} className="btn-home-small">🏠 Home</button>
          <button onClick={handleLogout} className="btn-logout-small">Logout</button>
        </div>
      </header>

      <div className="container" style={{maxWidth:'1200px', marginTop:'20px'}}>
        
        {/* PROFILE SECTION */}
        <div className={`profile-section ${formData.isVerified ? 'verified-bg' : 'unverified-bg'}`}>
            <div className="profile-header" onClick={() => setIsProfileExpanded(!isProfileExpanded)}>
                <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
                    <span style={{fontSize:'20px'}}>👤</span>
                    <div><h3 style={{margin:0}}>My Profile</h3><small>{formData.isVerified ? "✅ Verified Vendor" : "⚠️ Verification Pending"}</small></div>
                </div>
                <button className="btn-toggle">{isProfileExpanded ? "▲" : "▼"}</button>
            </div>
            
            {isProfileExpanded && (
                <div className="profile-body fade-in-up">
                    
                    {verifyError && <div className="error-msg">{verifyError}</div>}
                    
                    {/* NEW: Irreversible Warning Note */}
                    {!formData.isVerified && (
                      <div style={{background: '#fff3cd', color: '#856404', padding: '10px 15px', borderRadius: '6px', marginBottom: '20px', border: '1px solid #ffeeba', fontSize: '14px', fontWeight: 'bold'}}>
                        ⚠️ Please review all details carefully. Once verified, your information cannot be corrected again.
                      </div>
                    )}

                    <div className="form-grid">
                        {/* NEW: Read-Only Email */}
                        <div className="form-group">
                          <label>Email Address</label>
                          <input className="input-field" value={currentUser?.email || ""} disabled={true} style={{background: '#f1f3f5', color: '#6c757d', cursor: 'not-allowed'}} />
                        </div>
                        <div className="form-group"><label>Full Name</label><input className="input-field" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} disabled={formData.isVerified} placeholder="Enter Name" /></div>
                        <div className="form-group"><label>Address</label><input className="input-field" value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} disabled={formData.isVerified} placeholder="Enter Address" /></div>
                        <div className="form-group"><label>GST / Aadhar No.</label><input className="input-field" value={formData.gst} onChange={e => setFormData({...formData, gst: e.target.value})} disabled={formData.isVerified} placeholder="Enter GST or Aadhar" /></div>
                        <div className="form-group">
                            <label>Phone Number</label>
                            <div className="phone-input-group" style={{display:'flex', gap:'10px'}}>
                                <input className="input-field" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} disabled={formData.isVerified || verificationStep === "OTP_SENT"} placeholder="9876543210" />
                                {!formData.isVerified && verificationStep === "IDLE" && (
  <button onClick={sendOtp} className="btn-primary-small" disabled={isSendingOtp}>
    {isSendingOtp ? "Sending..." : "Send OTP 📲"}
  </button>
)}
                            </div>
                        </div>
                    </div>

                    {/* OTP SECTION WITH TIMER */}
                    {verificationStep === "OTP_SENT" && (
                        <div className="otp-area fade-in-up" style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                            <div style={{display: 'flex', gap: '10px', width: '100%'}}>
                              <input className="input-field" value={otp} onChange={e => setOtp(e.target.value)} placeholder="Enter OTP" maxLength={6} style={{flex: 1}}/>
                              <button onClick={verifyOtpAndSave} className="btn-primary-small" disabled={isVerifyingOtp}>
  {isVerifyingOtp ? "Verifying..." : "Verify & Save ✅"}
</button>
                            </div>
                            
                            {/* NEW: Resend Timer Logic */}
                            <div style={{marginTop: '10px', fontSize: '13px'}}>
                                {resendTimer > 0 ? (
                                  <span style={{color: '#7f8c8d'}}>Resend OTP available in <strong>{resendTimer}s</strong></span>
                                ) : (
                                  <button onClick={sendOtp} style={{background: 'none', border: 'none', color: '#3498db', fontWeight: 'bold', cursor: 'pointer', padding: 0}}>
                                    ↻ Resend OTP Now
                                  </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>

        {/* TABS */}
        <div className="tab-controls" style={{marginTop:'30px'}}>
            <button className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`} onClick={() => setActiveTab('all')}>📋 Active Tenders</button>
            <button className={`tab-btn ${activeTab === 'my-bids' ? 'active' : ''}`} onClick={() => setActiveTab('my-bids')}>📂 My Applications</button>
        </div>

        {/* CONTENT */}
        <div className="dashboard-content" style={{padding:'20px 0'}}>
            {activeTab === 'all' && (
                <div className="tender-grid">
                    {tenders.map(t => {
                        const closed = isTenderClosed(t.closeDate, t.closeTime);
                        const daysLeft = getDaysLeft(t.closeDate); 
                        const hasBid = myBids.some(b => b.tenderId === t.id);
                        return (
                            <div key={t.id} className={`tender-card ${closed ? 'closed-card' : ''}`}>
                                <div className="card-top">
                                    <span className="tender-id">Ref: {t.id.slice(0,6).toUpperCase()}</span>
                                    {closed ? <span className="badge-closed">Closed</span> : <span className="badge-days">{daysLeft} Days Left</span>}
                                </div>
                                <h3 className="tender-title">{t.title}</h3>
<p className="tender-desc">{t.description}</p>

{/* NEW: Date and Time Display */}
<div style={{fontSize: '12px', color: '#555', marginBottom: '15px', background: '#f1f3f5', padding: '10px', borderRadius: '6px', border: '1px solid #e9ecef'}}>
    <div style={{marginBottom: '4px'}}><strong>🟢 Opens:</strong> {t.openDate}</div>
    <div><strong>🛑 Closes:</strong> {t.closeDate} {t.closeTime ? `at ${t.closeTime}` : 'at 18:30'}</div>
</div>

<div className="card-actions">
                                    {t.fileUrl ? <a href={t.fileUrl} target="_blank" rel="noreferrer" className="btn-download">⬇ Document</a> : <button disabled className="btn-download disabled">No Doc</button>}
                                    
                                    {/* SHOW VIEW RESULT BUTTON IF CLOSED */}
                                    {closed ? (
                                        <button onClick={() => openResult(t)} className="btn-download" style={{background:'#6c5ce7', color:'white', border:'none', flex: 1.5}}>🏆 View Result</button>
                                    ) : (
                                        hasBid ? <button className="btn-applied" disabled>✅ Applied</button> : <button onClick={() => openApplyModal(t)} className="btn-apply">Apply Now ➤</button>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}

            {activeTab === 'my-bids' && (
                <div className="bids-list">
                    {myBids.length === 0 ? <p className="empty-msg">No applications found.</p> : (
                        <table className="bids-table">
                            <thead><tr><th>Tender</th><th>Quote</th><th>Status</th><th>Actions</th></tr></thead>
                            <tbody>
                                {myBids.map(b => (
                                    <tr key={b.id}>
                                        <td data-label="Tender"><strong>{b.tenderTitle}</strong></td>
                                        <td data-label="Quote">₹ {Number(b.amount).toLocaleString()}</td>
                                        <td data-label="Status">{getBidStatus(b)}</td>
                                        <td data-label="Actions">
                                            {isTenderClosed(b.tenderCloseDate, b.tenderCloseTime) ? (
                                                <span className="text-muted">Locked</span>
                                            ) : (
                                                <div className="action-buttons-container">
                                                    <button onClick={() => openEditModal(b)} className="btn-edit-small">Edit</button>
                                                    <button onClick={() => handleDeleteBid(b.id)} className="btn-delete-small">Withdraw</button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>
      </div>

      {/* RESULT MODAL */}
      {resultPopup && (
        <div className="modal-overlay" onClick={() => setResultPopup(null)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{maxWidth: '600px'}}>
            <div className="modal-header"><h3>Tender Result</h3><button onClick={() => setResultPopup(null)} className="btn-close">✖</button></div>
            <div className="modal-body">
              <h4 style={{marginBottom:'5px'}}>{resultPopup.title}</h4>
              <p style={{marginBottom:'20px', fontSize:'13px', color:'#666'}}>Ref: {resultPopup.id.slice(0,6).toUpperCase()}</p>
              
              {loadingResults ? (
                <div style={{padding:'20px'}}>Loading Results...</div>
              ) : (
                resultBids.length === 0 ? <p>No bids received.</p> : (
                    <div className="table-responsive">
                        <table className="bids-table" style={{boxShadow:'none', border:'1px solid #eee'}}>
                            <thead><tr style={{background:'#f8f9fa'}}><th>Rank</th><th>Bidder Name</th></tr></thead>
                            <tbody>
                                {resultBids.map((bid, index) => {
                                    let rowClass = "";
                                    let rankDisplay = index + 1;
                                    if (index === 0) { rowClass = "row-gold"; rankDisplay = "🏆 L1"; } 
                                    else if (index === 1) { rowClass = "row-silver"; rankDisplay = "🥈 L2"; }

                                    const isMe = bid.userId === currentUser.uid;
                                    const nameDisplay = isMe ? <span>{bid.bidderName} <strong style={{color:'#27ae60'}}>(You)</strong></span> : bid.bidderName;
                                    const rowStyle = isMe ? {background: '#e8f5e9', borderLeft: '4px solid #27ae60'} : {};

                                    return (
                                        <tr key={index} className={rowClass} style={rowStyle}>
                                            <td data-label="Rank"><strong>{rankDisplay}</strong></td>
                                            <td data-label="Name">{nameDisplay}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )
              )}
            </div>
            <div className="modal-footer"><button onClick={() => setResultPopup(null)} className="btn-primary-full">Close</button></div>
          </div>
        </div>
      )}

      {/* BID MODAL */}
      {showModal && selectedTender && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div className="modal-header"><h3>Official Bid Application</h3><button onClick={() => setShowModal(false)} className="btn-close">✖</button></div>
            <form onSubmit={handleSubmitBid} className="modal-body">
              <div className="tender-summary" style={{marginBottom: '20px'}}>
                <h4 style={{marginBottom: '10px'}}>{selectedTender.title}</h4>
                {selectedTender.fileUrl && (
                  <a 
                    href={selectedTender.fileUrl} 
                    target="_blank" 
                    rel="noreferrer" 
                    style={{display: 'inline-block', background: '#e3f2fd', color: '#1976d2', padding: '8px 16px', borderRadius: '6px', fontWeight: 'bold', textDecoration: 'none', border: '1px solid #bbdefb', boxShadow: '0 2px 4px rgba(0,0,0,0.05)'}}
                  >
                    ⬇ Download Official Tender Document
                  </a>
                )}
              </div>

              {/* NEW: Secretary Contact Banner */}
              <div style={{ background: '#e0f7fa', border: '1px solid #b2ebf2', padding: '12px 15px', borderRadius: '8px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: '13px', color: '#006064', fontWeight: 'bold' }}>Need help with this tender?</div>
                  <div style={{ fontSize: '11px', color: '#00838f' }}>Contact the Society Secretary</div>
                </div>
                <a 
                  href="tel:+919872348700" 
                  style={{ background: '#00838f', color: 'white', padding: '8px 15px', borderRadius: '6px', fontWeight: 'bold', textDecoration: 'none', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                >
                  📞 +91 9872348700
                </a>
              </div>
              
              <div className="form-group">
                <label>Bid Amount (INR)</label>
                <input type="number" className="input-field" value={bidForm.amount} onChange={e => setBidForm({...bidForm, amount: e.target.value})} required />
              </div>
              
              <div className="form-group">
                <label>Upload Proposal if required in the tender or leave empty (PDF only)</label>
                <input 
                  type="file" 
                  className="input-field" 
                  accept="application/pdf"
                  style={{marginBottom: '4px'}}
                  onChange={e => {
                    const selectedFile = e.target.files[0];
                    if (selectedFile && selectedFile.size > 15 * 1024 * 1024) {
                      alert("⚠️ File size exceeds the 15MB limit. Please upload a smaller document.");
                      e.target.value = ""; 
                      setBidForm({...bidForm, file: null});
                    } else {
                      setBidForm({...bidForm, file: selectedFile});
                    }
                  }} 
                />
                <small style={{color: '#7f8c8d', fontWeight: '500', display: 'block', marginBottom: '10px'}}>
                  * Please ensure your document is under 15MB.
                </small>
              </div>
              <div style={{ marginTop: '20px', background: '#f8f9fa', padding: '15px', borderRadius: '8px', border: '1px solid #ddd' }}>
                <label style={{ fontSize: '14px', fontWeight: 'bold', color: '#c0392b', marginBottom: '15px', display: 'block', borderBottom: '1px dashed #ccc', paddingBottom: '8px' }}>
                  ਲਾਜ਼ਮੀ ਸ਼ਰਤਾਂ (Mandatory Declarations): 
                </label>
                {bidChecklistItems.map((itemText, index) => (
                  <label key={index} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '13px', color: '#444', marginBottom: '12px', cursor: 'pointer', lineHeight: '1.4' }}>
                    <input 
                      type="checkbox" 
                      style={{ marginTop: '3px', width: '18px', height: '18px', flexShrink: 0, cursor: 'pointer' }}
                      checked={bidChecklist[index]} 
                      onChange={(e) => {
                        const newChecklist = [...bidChecklist];
                        newChecklist[index] = e.target.checked;
                        setBidChecklist(newChecklist);
                      }} 
                    />
                    <span>{itemText}</span>
                  </label>
                ))}
              </div>
              
              <div className="modal-footer" style={{flexDirection: 'column', gap: '10px'}}>
                {!allBidChecked && !submitting && (
                  <p style={{ color: '#c0392b', fontSize: '12px', textAlign: 'center', margin: '0 0 5px 0', fontWeight: 'bold' }}>
                      ਕਿਰਪਾ ਕਰਕੇ ਬੋਲੀ ਜਮ੍ਹਾਂ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਉੱਪਰ ਦਿੱਤੀਆਂ ਸਾਰੀਆਂ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤੀ ਪ੍ਰਗਟ ਕਰੋ।
                  </p>
                )}
                <button 
                  type="submit" 
                  disabled={submitting || !allBidChecked} 
                  className="btn-primary-full"
                  style={{ opacity: (!allBidChecked && !submitting) ? 0.6 : 1 }}
                >
                  {submitting ? "Submitting Application..." : (editingBidId ? "Update Bid Application" : "Submit Official Bid")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      
      {/* PASSWORD MODAL */}
      {showPassModal && (
        <div className="modal-overlay">
          <div className="modal-box" style={{maxWidth: '400px'}}>
            <div className="modal-header" style={{background: '#f39c12'}}><h3>Change Password</h3><button onClick={() => setShowPassModal(false)} className="btn-close">✖</button></div>
            <form onSubmit={handlePasswordChange} className="modal-body">
                <div className="form-group"><label>New Password</label><input type="password" className="input-field" value={passForm.newPass} onChange={e => setPassForm({...passForm, newPass: e.target.value})} required minLength={6}/></div>
                <div className="form-group"><label>Confirm Password</label><input type="password" className="input-field" value={passForm.confirmPass} onChange={e => setPassForm({...passForm, confirmPass: e.target.value})} required minLength={6}/></div>
                <div className="modal-footer"><button type="submit" className="btn-primary-full" style={{background: '#f39c12'}}>Update Password</button></div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default BidderDashboard;